// extracted by mini-css-extract-plugin
export default {"card":"landing_card__ySwna","overlay":"landing_overlay__oMcD0","content":"landing_content__3Yw5S","heading":"landing_heading__GaRkv","sub":"landing_sub__W2owH"};